import { render } from "./LinkFrame.vue?vue&type=template&id=038e6314&scoped=true"
import script from "./LinkFrame.vue?vue&type=script&lang=js"
export * from "./LinkFrame.vue?vue&type=script&lang=js"

import "./LinkFrame.vue?vue&type=style&index=0&id=038e6314&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038e6314"]])

export default __exports__